const styles = () => ({
    containerBtn: {
        marginTop: '30px',
        marginBottom: '150px',
        textAlign: 'center',
    },
    searchRequest: {
        borderRadius: '50px',
        paddingRight: '50px',
        paddingLeft: '50px',
        height: '60px',
        boxShadow: '0px 5px 20px rgba(40,150,190,.8)',
    },
    noRequest: {
        borderTop: '55px solid #efefef',
        marginTop: '-45px',
        paddingTop: '20px',
        textAlign: 'center',
        fontSize: '16px',
        color: '#666',
    },
    containerSearchField: {
        marginTop: '10px',
    },
});

export default styles;
